import { type FunctionalComponent, h } from '@stencil/core';

interface IProductNaSelector {
  accessibilityMode: boolean;
  title: string;
  country: string;
  language: string;
  locales: string;
}

export const UIaaSProductNaSelector: FunctionalComponent<IProductNaSelector> = (props) => {
    const endpoint = `https://www.se.com/${props.country}/${props.language}/download/download-api/getCountryLabels/`;

    return (
      <country-selector
        cs_endpoint={endpoint}
        country_code={props.country}
        language_code={props.language}
        app_source="SE"
        locales={props.locales}
        cs_title={props.title}
        not_scoped_message="The specified document is not available anywhere.." //! for next phase, when items availability will be implemented
        toggle_click={props.accessibilityMode}
        enable_close='true'
        consumer_name="search"
      />
    );
};
